import _ from 'lodash'

export const mapValues: MapValues = (obj, fn) => _.mapValues(obj, (value, id) => fn(value, id))
type MapValues = <TMap extends Record<string, any>, TValue, TTo = TMap[string]>(
	obj: TMap,
	fn: (value: TTo, id: string) => TValue
) => Record<string, TValue>
